<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="12.828" height="7.414" viewBox="0 0 12.828 7.414">
        <path
            id="Icon_Chevron"
            data-name="Icon / Chevron"
            d="M58,96l-5,5-5-5"
            transform="translate(-46.586 -94.586)"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2" />
    </svg>
</template>
